"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var profile_api_1 = require("@l2p/profile-api");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var DetailBox_1 = require("../../DetailBox");
var ValidUntil_1 = require("../../ValidUntil");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var calculateWagerWidth = function (startWageringBalance, wageringBalance) {
    var start = Number(startWageringBalance) || 0;
    var current = Number(wageringBalance) || 0;
    return start > 0
        ? Math.min(Math.max(((start - current) / start) * 100, 0), 100)
        : 0;
};
var ActiveBonus = function (_a) {
    var _b, _c, _d;
    var bonus = _a.bonus, cancelBonus = _a.cancelBonus;
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var router = (0, navigation_1.useRouter)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var openPromotions = (0, react_1.useCallback)(function () {
        router.push(generateUrlWithLang("/games/bonus"));
    }, [generateUrlWithLang, router]);
    var maxBet = (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d;
        var maxBet = (_c = (_b = (_a = bonus === null || bonus === void 0 ? void 0 : bonus.bonus) === null || _a === void 0 ? void 0 : _a.constraints) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.type === profile_api_1.BonusConstraintType.MaxBet; })) === null || _c === void 0 ? void 0 : _c.maxBet;
        return (_d = maxBet === null || maxBet === void 0 ? void 0 : maxBet.find(function (item) { return item.currency === bonus.currency; })) === null || _d === void 0 ? void 0 : _d.amount;
    }, [bonus === null || bonus === void 0 ? void 0 : bonus.currency, (_b = bonus === null || bonus === void 0 ? void 0 : bonus.bonus) === null || _b === void 0 ? void 0 : _b.constraints]);
    var title = (0, react_1.useMemo)(function () {
        var _a;
        if ((bonus === null || bonus === void 0 ? void 0 : bonus.type) === profile_api_1.BonusCardType.FreeRounds)
            return t('freespinsWinnings');
        return (_a = bonus === null || bonus === void 0 ? void 0 : bonus.bonus) === null || _a === void 0 ? void 0 : _a.title;
    }, [bonus === null || bonus === void 0 ? void 0 : bonus.type, (_c = bonus === null || bonus === void 0 ? void 0 : bonus.bonus) === null || _c === void 0 ? void 0 : _c.title, t]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, title),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.timerAndReject },
                react_1.default.createElement(ValidUntil_1.ValidUntil, { bonus: bonus }),
                react_1.default.createElement("button", { className: styles_module_scss_1.default.rejectBtn, onClick: function () {
                        cancelBonus(bonus);
                    } },
                    react_1.default.createElement("span", null, t('reject'))))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusContainer },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus }, "".concat((0, apps_shared_1.getCurrencySymbol)(bonus === null || bonus === void 0 ? void 0 : bonus.currency), " ").concat(Number(bonus === null || bonus === void 0 ? void 0 : bonus.startBalance).toFixed(2))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusBalance },
                t('bonusBalance'),
                "\u00A0", "".concat((0, apps_shared_1.getCurrencySymbol)(bonus.currency), " ").concat(Number(bonus.balance).toFixed(2) || 0))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusDetails },
            react_1.default.createElement("div", null,
                react_1.default.createElement(DetailBox_1.DetailBox, null,
                    t('maxBet'),
                    react_1.default.createElement("span", null, maxBet ? (react_1.default.createElement(react_1.default.Fragment, null,
                        (0, apps_shared_1.getCurrencySymbol)(bonus === null || bonus === void 0 ? void 0 : bonus.currency),
                        "\u00A0",
                        Number(maxBet).toFixed(2))) : ('N/A'))),
                react_1.default.createElement(DetailBox_1.DetailBox, null,
                    t('wager'),
                    react_1.default.createElement("span", null, ((_d = bonus === null || bonus === void 0 ? void 0 : bonus.bonus) === null || _d === void 0 ? void 0 : _d.wageringMultiplier) ? (react_1.default.createElement(react_1.default.Fragment, null,
                        "x",
                        bonus.bonus.wageringMultiplier)) : ('N/A'))),
                (bonus === null || bonus === void 0 ? void 0 : bonus.startWageringBalance) && (react_1.default.createElement(DetailBox_1.DetailBox, { fullWidth: true },
                    breakpoints.mobile ? t('wagered') : t('amountWagered'),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.progress },
                        react_1.default.createElement("span", { style: {
                                width: "".concat(calculateWagerWidth(bonus === null || bonus === void 0 ? void 0 : bonus.startWageringBalance, bonus === null || bonus === void 0 ? void 0 : bonus.wageringBalance), "%"),
                            } })),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("span", null, "".concat(Number(Number((bonus === null || bonus === void 0 ? void 0 : bonus.startWageringBalance) || 0) -
                            Number((bonus === null || bonus === void 0 ? void 0 : bonus.wageringBalance) || 0)).toFixed(2))), " / ".concat((0, apps_shared_1.getCurrencySymbol)(bonus === null || bonus === void 0 ? void 0 : bonus.currency), " ").concat(Number(bonus === null || bonus === void 0 ? void 0 : bonus.startWageringBalance).toFixed(2)))))),
            react_1.default.createElement(ui_components_1.FixedButton, { onClick: openPromotions, className: styles_module_scss_1.default.playButton, width: "100%", maxWidth: "200px", text: "upper", color: "gradient" }, t('play')))));
};
exports.default = ActiveBonus;
